/** @format */

import { NavLink } from 'react-router-dom';
import classNames from 'classnames/bind';
import { ReactComponent as RightArrow } from '../../assets/arrow-right.svg';
import styles from './Method.module.css';
import { methodKeyToLogo, methodKeyToName } from './utils';

const cx = classNames.bind(styles);

export type MethodKeyType =
	| 'mono'
	| 'transfer'
	| 'card'
	| 'ussd'
	| 'kuda'
	| 'mpesa'
	| 'cellulant'
	| 'stitch'
	| 'mobileeast'
	| 'business'
    | 'mobile'

export const Method = ({ methodKey, onClick }: { methodKey: MethodKeyType, onClick?: any }) => {
	return (
		<NavLink
			className={({ isActive }) => {
				return cx({ container: true, active: isActive });
			}}
			to={`/${methodKey}`}
            onClick={onClick}
			end
		>
			<div className={styles.method}>
				<span className={styles.inactive_nav}>
					{methodKeyToLogo[methodKey]}
				</span>
				<p className={styles.methodName}>{methodKeyToName[methodKey]}</p>
			</div>
			<RightArrow className={styles.angleArrowMethods} />
		</NavLink>
	);
};
